import {
  Icon4SquareSolid,
  IconAccountsDefault,
  IconAccountSelected,
  IconAccountsSelect,
  IconAccountUnselect,
  IconActiveCooperation,
  IconActiveCooperation2,
  IconActiveCooperationSelected,
  IconActiveCooperationUnselected,
  IconActiveCreator,
  IconActiveLivePartners,
  IconAdd,
  IconAddBold,
  IconAds,
  IconAiSticker,
  IconApprove,
  IconArrow,
  IconArrowCircle,
  IconArrowDown,
  IconArrowDownFill,
  IconArrowDownWithColor,
  IconArrowLeft,
  IconArrowLeftButton,
  IconArrowRight,
  IconArrowRightButton,
  IconArrowTurnUpRight,
  IconArrowUp,
  IconArrowUpFill,
  IconArrowUpWithColor,
  IconAwaitingShipment,
  IconBag,
  IconBeauty,
  IconBidding,
  IconBiddingFill,
  IconBillboard,
  IconBlackFridayTag,
  IconBlock,
  IconBoltFill,
  IconCalendar,
  IconCampaignSelected,
  IconCampaignUnselect,
  IconChart,
  IconChatDefault,
  IconChatDefaultGreen,
  IconChatSelect,
  IconChatSelectGreen,
  IconCheckCircle,
  IconCleanUp,
  IconClickSolid,
  IconClockSolid,
  IconClosecircle,
  IconCollaborationSelected,
  IconCollaborationUnselected,
  IconCommissons,
  IconComponent15,
  IconComputer,
  IconConcactPerson,
  IconContact,
  IconContactSeller,
  IconCopy,
  IconCreatorDefault,
  IconCreatorDefaultGreen,
  IconCreatorSalesRate,
  IconCreatorSelect,
  IconCreatorSelectGreen,
  IconCross,
  IconCursorMove,
  IconCustomerGroup,
  IconDataDefault,
  IconDataSelect,
  IconDataSelected,
  IconDataUnselect,
  IconDelete,
  IconDelete2,
  IconDeleteThin,
  IconDeleteThinGreen,
  IconDiligentPromotion,
  IconDiligentPromotion2,
  IconDiligentPromotionSelected,
  IconDiligentPromotionUnselected,
  IconDiscoverCreatorsSelected,
  IconDiscoverCreatorsUnselected,
  IconDocSolid,
  IconDollarSignFill,
  IconDollarSignOutline,
  IconDoubleLeft,
  IconDoubleRight,
  IconDowload,
  IconDown,
  IconDrag,
  IconDuplicate,
  IconEdit,
  IconEdit2,
  IconEditMetrics,
  IconEmail,
  IconEnvelope,
  IconEquation,
  IconEquationBold,
  IconError,
  IconExcel,
  IconExclamationCircle,
  IconExcludedCreator,
  IconExclusiveStock,
  IconFacebookCircle,
  IconFastGrowing,
  IconFastGrowing2,
  IconFastGrowingFill,
  IconFastGrowingSelected,
  IconFastGrowingUnselected,
  IconFileImage,
  IconFilledBulb,
  IconFilter,
  IconFinanceDefault,
  IconFinanceSelect,
  IconFindCreatorsDefault,
  IconFindCreatorsSelect,
  IconFindmcnDefault,
  IconFindmcnSelect,
  IconFindMcnSelected,
  IconFindMcnUnselected,
  IconFireFill,
  IconFolder,
  IconFreeSampleView,
  IconFunction,
  IconGenderSolid,
  IconGift,
  IconGiftSelected,
  IconGiftUnselected,
  IconGiveaway,
  IconGPM,
  IconGridView,
  IconGuidance,
  IconHelpDefault,
  IconHelpSelect,
  IconHide,
  IconHighSampleDispatchRate,
  IconHomeDefault,
  IconHomeSelect,
  IconHomeSelected,
  IconHomeUnselect,
  IconIM,
  IconImportant,
  IconImTable,
  IconInfluencerSelected,
  IconInfluencerUnselect,
  IconInfoSolid,
  IconInvite,
  IconInvite2,
  IconLanguage,
  IconLanguages,
  IconLeft,
  IconLetter,
  IconLightning,
  IconLikeSolid,
  IconLineChart,
  IconLineCircle,
  IconLink,
  IconList,
  IconListArrowDown,
  IconListView,
  IconLIVEDefault,
  IconLiveRate,
  IconLIVESelect,
  IconLivestreamingSelected,
  IconLivestreamingUnselecte,
  IconLogout,
  IconMark2,
  IconMcnPhone,
  IconMenuAccountDefault,
  IconMenuAccountSelect,
  IconMenuDataDefault,
  IconMenuDataSelect,
  IconMenuFindCreatorDefault,
  IconMenuFindCreatorSelect,
  IconMenuHomeDefault,
  IconMenuHomeSelect,
  IconMenuOrderDefault,
  IconMenuOrderSelect,
  IconMenuPartnerCampaignDefault,
  IconMenuPartnerCampaignSelect,
  IconMenuPlanDefault,
  IconMenuPlanSelect,
  IconMenuSampleDefault,
  IconMenuSampleSelect,
  IconMessage,
  IconMessageFill,
  IconMessageSolid,
  IconMoney,
  IconMonthlyRevenue,
  IconMoon,
  IconMore,
  IconMute,
  IconNA,
  IconNewApprove,
  IconNewOrder1,
  IconNewOrder2,
  IconNewOrder3,
  IconNewOrder4,
  IconNewRefresh,
  IconNewReject,
  IconNotification,
  IconOrder,
  IconOrder1,
  IconOrder2,
  IconOrder3,
  IconOrderDefault,
  IconOrderSelect,
  IconOrderSelected,
  IconOrderUnselect,
  IconPaperSize,
  IconPartnersWithSales,
  IconPeakRevenue,
  IconPeoplePlaceholder,
  IconPeopleSolid,
  IconPercentageUp,
  IconPersonAddSelected,
  IconPersonAddUnselected,
  IconPersonPenSelected,
  IconPersonPenUnselected,
  IconPhone,
  IconPhoneCircle,
  IconPin,
  IconPinFill,
  IconPinSolid,
  IconPlanDefault,
  IconPlanlistDefault,
  IconPlanlistDefaultGreen,
  IconPlanlistSelect,
  IconPlanlistSelectGreen,
  IconPlanSelect,
  IconPlaySolid,
  IconPopularContent,
  IconPopularContent2,
  IconPopularContentFill,
  IconPopularContentSelected,
  IconPopularContentUnselected,
  IconPosition,
  IconPositionGreen,
  IconPositive,
  IconPrint,
  IconPrintThin,
  IconProduct,
  IconProductiveCreatorFill,
  IconProductsDefault,
  IconProductsDefaultGreen,
  IconProductsSelect,
  IconProductsSelectGreen,
  IconProfile,
  IconPromotion,
  IconPromotionEfficiency,
  IconPromotionEfficiency2,
  IconPromotionEfficiencySelected,
  IconPromotionEfficiencyUnselected,
  IconProperty1,
  IconProperty2,
  IconProperty3,
  IconPublished,
  IconQRCode,
  IconQuestion,
  IconQuestionThin,
  IconQuickResponse,
  IconRaiseSelected,
  IconRaiseUnselect,
  IconRecommend,
  IconRecover,
  IconReplace,
  IconRevenue,
  IconRevenueGrowthRate,
  IconReverse,
  IconRight,
  IconRightM4b,
  IconROI,
  IconSales,
  IconSalesRate,
  IconSampleRequestDefault,
  IconSampleRequestSelect,
  IconSaved,
  IconSearch,
  IconSendTargetplan,
  IconShop,
  IconShoppingBagTickFill,
  IconShopSelected,
  IconShopUnselected,
  IconShow,
  IconShowcaseDefault,
  IconShowcaseSelect,
  IconSort,
  IconSound,
  IconStar,
  IconStar16,
  IconStarDefault,
  IconStarFill,
  IconStarSelect,
  IconStepDot,
  IconStop,
  IconSubscribeAddFill,
  IconSuccess,
  IconSuggestion,
  IconSun,
  IconThumbsUpFill,
  IconThumbUp,
  IconTick,
  IconTikTokLogoDark,
  IconTiltLightBulb,
  IconTop,
  IconTopCollaboratorsFill,
  IconTopSalesFill,
  IconTrashBin,
  IconTTtick,
  IconUnblock,
  IconUnsaved,
  IconUnstar,
  IconUp,
  IconUpdateProduct,
  IconUpload,
  IconUpSolid,
  IconVector,
  IconViberCircle,
  IconVideoFill,
  IconView,
  IconViewSoild,
  IconViewThin,
  IconWarehouse,
  IconWarning,
  IconWarningGreen,
  IconZaloCircle,
  IconProps,
} from '@features/icon';

const ICON_MAP: { [key: string]: React.FC<IconProps> } = {
  Icon4SquareSolid,
  IconAccountsDefault,
  IconAccountSelected,
  IconAccountsSelect,
  IconAccountUnselect,
  IconActiveCooperation,
  IconActiveCooperation2,
  IconActiveCooperationSelected,
  IconActiveCooperationUnselected,
  IconActiveCreator,
  IconActiveLivePartners,
  IconAdd,
  IconAddBold,
  IconAds,
  IconAiSticker,
  IconApprove,
  IconArrow,
  IconArrowCircle,
  IconArrowDown,
  IconArrowDownFill,
  IconArrowDownWithColor,
  IconArrowLeft,
  IconArrowLeftButton,
  IconArrowRight,
  IconArrowRightButton,
  IconArrowTurnUpRight,
  IconArrowUp,
  IconArrowUpFill,
  IconArrowUpWithColor,
  IconAwaitingShipment,
  IconBag,
  IconBeauty,
  IconBidding,
  IconBiddingFill,
  IconBillboard,
  IconBlackFridayTag,
  IconBlock,
  IconBoltFill,
  IconCalendar,
  IconCampaignSelected,
  IconCampaignUnselect,
  IconChart,
  IconChatDefault,
  IconChatDefaultGreen,
  IconChatSelect,
  IconChatSelectGreen,
  IconCheckCircle,
  IconCleanUp,
  IconClickSolid,
  IconClockSolid,
  IconClosecircle,
  IconCollaborationSelected,
  IconCollaborationUnselected,
  IconCommissons,
  IconComponent15,
  IconComputer,
  IconConcactPerson,
  IconContact,
  IconContactSeller,
  IconCopy,
  IconCreatorDefault,
  IconCreatorDefaultGreen,
  IconCreatorSalesRate,
  IconCreatorSelect,
  IconCreatorSelectGreen,
  IconCross,
  IconCursorMove,
  IconCustomerGroup,
  IconDataDefault,
  IconDataSelect,
  IconDataSelected,
  IconDataUnselect,
  IconDelete,
  IconDelete2,
  IconDeleteThin,
  IconDeleteThinGreen,
  IconDiligentPromotion,
  IconDiligentPromotion2,
  IconDiligentPromotionSelected,
  IconDiligentPromotionUnselected,
  IconDiscoverCreatorsSelected,
  IconDiscoverCreatorsUnselected,
  IconDocSolid,
  IconDollarSignFill,
  IconDollarSignOutline,
  IconDoubleLeft,
  IconDoubleRight,
  IconDowload,
  IconDown,
  IconDrag,
  IconDuplicate,
  IconEdit,
  IconEdit2,
  IconEditMetrics,
  IconEmail,
  IconEnvelope,
  IconEquation,
  IconEquationBold,
  IconError,
  IconExcel,
  IconExclamationCircle,
  IconExcludedCreator,
  IconExclusiveStock,
  IconFacebookCircle,
  IconFastGrowing,
  IconFastGrowing2,
  IconFastGrowingFill,
  IconFastGrowingSelected,
  IconFastGrowingUnselected,
  IconFileImage,
  IconFilledBulb,
  IconFilter,
  IconFinanceDefault,
  IconFinanceSelect,
  IconFindCreatorsDefault,
  IconFindCreatorsSelect,
  IconFindmcnDefault,
  IconFindmcnSelect,
  IconFindMcnSelected,
  IconFindMcnUnselected,
  IconFireFill,
  IconFolder,
  IconFreeSampleView,
  IconFunction,
  IconGenderSolid,
  IconGift,
  IconGiftSelected,
  IconGiftUnselected,
  IconGiveaway,
  IconGPM,
  IconGridView,
  IconGuidance,
  IconHelpDefault,
  IconHelpSelect,
  IconHide,
  IconHighSampleDispatchRate,
  IconHomeDefault,
  IconHomeSelect,
  IconHomeSelected,
  IconHomeUnselect,
  IconIM,
  IconImportant,
  IconImTable,
  IconInfluencerSelected,
  IconInfluencerUnselect,
  IconInfoSolid,
  IconInvite,
  IconInvite2,
  IconLanguage,
  IconLanguages,
  IconLeft,
  IconLetter,
  IconLightning,
  IconLikeSolid,
  IconLineChart,
  IconLineCircle,
  IconLink,
  IconList,
  IconListArrowDown,
  IconListView,
  IconLIVEDefault,
  IconLiveRate,
  IconLIVESelect,
  IconLivestreamingSelected,
  IconLivestreamingUnselecte,
  IconLogout,
  IconMark2,
  IconMcnPhone,
  IconMenuAccountDefault,
  IconMenuAccountSelect,
  IconMenuDataDefault,
  IconMenuDataSelect,
  IconMenuFindCreatorDefault,
  IconMenuFindCreatorSelect,
  IconMenuHomeDefault,
  IconMenuHomeSelect,
  IconMenuOrderDefault,
  IconMenuOrderSelect,
  IconMenuPartnerCampaignDefault,
  IconMenuPartnerCampaignSelect,
  IconMenuPlanDefault,
  IconMenuPlanSelect,
  IconMenuSampleDefault,
  IconMenuSampleSelect,
  IconMessage,
  IconMessageFill,
  IconMessageSolid,
  IconMoney,
  IconMonthlyRevenue,
  IconMoon,
  IconMore,
  IconMute,
  IconNA,
  IconNewApprove,
  IconNewOrder1,
  IconNewOrder2,
  IconNewOrder3,
  IconNewOrder4,
  IconNewRefresh,
  IconNewReject,
  IconNotification,
  IconOrder,
  IconOrder1,
  IconOrder2,
  IconOrder3,
  IconOrderDefault,
  IconOrderSelect,
  IconOrderSelected,
  IconOrderUnselect,
  IconPaperSize,
  IconPartnersWithSales,
  IconPeakRevenue,
  IconPeoplePlaceholder,
  IconPeopleSolid,
  IconPercentageUp,
  IconPersonAddSelected,
  IconPersonAddUnselected,
  IconPersonPenSelected,
  IconPersonPenUnselected,
  IconPhone,
  IconPhoneCircle,
  IconPin,
  IconPinFill,
  IconPinSolid,
  IconPlanDefault,
  IconPlanlistDefault,
  IconPlanlistDefaultGreen,
  IconPlanlistSelect,
  IconPlanlistSelectGreen,
  IconPlanSelect,
  IconPlaySolid,
  IconPopularContent,
  IconPopularContent2,
  IconPopularContentFill,
  IconPopularContentSelected,
  IconPopularContentUnselected,
  IconPosition,
  IconPositionGreen,
  IconPositive,
  IconPrint,
  IconPrintThin,
  IconProduct,
  IconProductiveCreatorFill,
  IconProductsDefault,
  IconProductsDefaultGreen,
  IconProductsSelect,
  IconProductsSelectGreen,
  IconProfile,
  IconPromotion,
  IconPromotionEfficiency,
  IconPromotionEfficiency2,
  IconPromotionEfficiencySelected,
  IconPromotionEfficiencyUnselected,
  IconProperty1,
  IconProperty2,
  IconProperty3,
  IconPublished,
  IconQRCode,
  IconQuestion,
  IconQuestionThin,
  IconQuickResponse,
  IconRaiseSelected,
  IconRaiseUnselect,
  IconRecommend,
  IconRecover,
  IconReplace,
  IconRevenue,
  IconRevenueGrowthRate,
  IconReverse,
  IconRight,
  IconRightM4b,
  IconROI,
  IconSales,
  IconSalesRate,
  IconSampleRequestDefault,
  IconSampleRequestSelect,
  IconSaved,
  IconSearch,
  IconSendTargetplan,
  IconShop,
  IconShoppingBagTickFill,
  IconShopSelected,
  IconShopUnselected,
  IconShow,
  IconShowcaseDefault,
  IconShowcaseSelect,
  IconSort,
  IconSound,
  IconStar,
  IconStar16,
  IconStarDefault,
  IconStarFill,
  IconStarSelect,
  IconStepDot,
  IconStop,
  IconSubscribeAddFill,
  IconSuccess,
  IconSuggestion,
  IconSun,
  IconThumbsUpFill,
  IconThumbUp,
  IconTick,
  IconTikTokLogoDark,
  IconTiltLightBulb,
  IconTop,
  IconTopCollaboratorsFill,
  IconTopSalesFill,
  IconTrashBin,
  IconTTtick,
  IconUnblock,
  IconUnsaved,
  IconUnstar,
  IconUp,
  IconUpdateProduct,
  IconUpload,
  IconUpSolid,
  IconVector,
  IconViberCircle,
  IconVideoFill,
  IconView,
  IconViewSoild,
  IconViewThin,
  IconWarehouse,
  IconWarning,
  IconWarningGreen,
  IconZaloCircle,
};

export default ICON_MAP;
